module.exports = __webpack_public_path__ + "img/tante_Riek_riekengeitje600x600px.13bd6fa8.png";